﻿import $ from "jquery";

window.$ = window.jQuery = $;

import "bootstrap/js/src/collapse";
import "bootstrap/js/src/carousel";

import "./modules/image-gallery";

$("#searchBtn").on("click", function () {
    $("#searchField").focus();
});
